import React, { useState } from 'react';
import Img from './gatsby-astronaut.png'
export default function Test() {
    const [count, setCount] = useState(1)
    return <h1 onClick={()=>setCount(count +1)}>Click me ( this is a react component) {count} <img src={Img} alt="Logo" /></h1>
}